import React from "react";
import { PrimaryButton } from "@/components/Buttons";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#090B0E] px-6 text-center" data-testid="notfound-page">
      <span className="font-display text-7xl font-extrabold flame-text">404</span>
      <h1 className="mt-4 font-display text-2xl font-semibold text-white">Pagina niet gevonden</h1>
      <p className="mt-3 max-w-md text-slate-400">De pagina die je zoekt bestaat niet of is verplaatst.</p>
      <div className="mt-8"><PrimaryButton to="/" testid="notfound-home-btn">Terug naar home</PrimaryButton></div>
    </div>
  );
}
